import { appLocalStorage, appSessionStorage } from '@/app/shared/services';
import { apiBaseUrl, dlAuthToken, peAuthToken } from '@/environment/environment';

/**
 * @description JWT Service class
 * This is responsible for logging of all kind of stuff in the application
 * Default, we are using the console api for logging and this provides the basic level of logging such as
 * you can use the available method of console in developement but in production these will be replaced with empty methods
 * This can be extended with the help of adding Log level functionality
 */
const dlTokenKey = "dl_token";
const peTokenKey = "pe_token";
const tokenKey = "accessToken";
const tokenExpiryKey = 'tokenExpiry';

class JwtService {

  /**
   * @constructor JwtService
   */
  constructor() {
    /** Initializing the configuration of jwtService */
    this.initJwtService();
  }

  /**
   * @description Initializing the configuration such as if environment is production then all log method will be replaced with empty methods
   * except logToServer, which will be responsible for logging the important stuff on server
   */
  initJwtService() {
    appLocalStorage.setItem(dlTokenKey, dlAuthToken);
    appLocalStorage.setItem(peTokenKey, peAuthToken);
  }

  getToken(key) {
    if(key) {
      return appLocalStorage.getItem(key);
    }
    return appLocalStorage.getItem(tokenKey);    
  }
 
  saveToken(token) {
    // Convert the JWT expiry time from seconds to milliseconds
    let tokenExpiry = Date.now() + 86400000;
    appLocalStorage.setItem(tokenExpiryKey, tokenExpiry);
    appLocalStorage.setItem(tokenKey, token);
    appLocalStorage.setItem(dlTokenKey, dlAuthToken);
    appLocalStorage.setItem(peTokenKey, peAuthToken);
  }

  destroyToken() {
    appLocalStorage.removeItem(tokenExpiryKey);
    appLocalStorage.removeItem(tokenKey);
    appLocalStorage.removeItem(dlTokenKey);
    appLocalStorage.removeItem(peTokenKey);
  }
}

/** Creating the instance of logger */
const jwt = new JwtService();

export { jwt };